import React from "react";
import { useClusters } from "gql/hooks/clusters/clusters.hook";
import { ZoneSelectorProps } from "./SlashZoneSelect.types";
import { ZoneSelect } from "../ZoneSelect/ZoneSelect";

export const SlashZoneSelect = ({
    selected,
    onChange,
    disabled,
}: ZoneSelectorProps) => {
    const { clusters: zones } = useClusters();
    return (
        <ZoneSelect
            zones={zones.filter(zone => zone.isAvailable)}
            selected={selected}
            onChange={onChange}
            disabled={disabled}
        />
    );
};
